import type { SupportedLanguage } from './getSupportedLanguages'
import { getSupportedLanguages } from './getSupportedLanguages'

export const isSupportedLanguage = (
  language: string,
): language is SupportedLanguage => {
  const supportedLanguages = getSupportedLanguages()

  return supportedLanguages.includes(language as SupportedLanguage)
}
